import { useEffect } from "react";
import { isCartazFormat } from "../../../../services/Utils";

//FONTS
export const ARIAL_FONT = "arial";
export const TIMES_NEW_ROMAN_FONT = "times new roman";
export const ROBOTO_FONT = "roboto";
export const PROTEST_STRIKE_FONT = "Protest Strike";
export const UBUNTU_FONT = "Ubuntu";
export const INTER_FONT = "Inter";
export const BLINKER_FONT = "Blinker";
export const ALEO_FONT = "Aleo";
export const OSWALD_FONT = "Oswald";
export const POPPINS_FONT = "Poppins";
export const STAATLICHES_FONT = "Staatliches";
export const TEKO_FONT = "Teko";
export const LONKIA_BRUSH_FONT = "Lonkia Brush";
export const SUMBER_BRUSH_FONT = "Sumber Brush";
export const GRANESTA_FONT = "Granesta";
export const BRUSH_ROUTA_FONT = "Brush Routa";
export const HUGEON_FONT = "Hugeon";
export const EUGENIA_FONT = "Eugenia";
export const SKETCHER = "Sketcher";

export const ENCARTE_FONT_FAMILIES = [
  PROTEST_STRIKE_FONT,
  ALEO_FONT,
  BLINKER_FONT,
  OSWALD_FONT,
  POPPINS_FONT,
  ROBOTO_FONT,
  STAATLICHES_FONT,
  TEKO_FONT,
  UBUNTU_FONT,
];

export const CARTAZ_FONTS = [
  PROTEST_STRIKE_FONT,
  BRUSH_ROUTA_FONT,
  LONKIA_BRUSH_FONT,
  SUMBER_BRUSH_FONT,
  GRANESTA_FONT,
  OSWALD_FONT,
  TEKO_FONT,
  HUGEON_FONT,
  EUGENIA_FONT,
  SKETCHER,
];

export default function useFormatFontFamily(styles, onStylesChange) {
  const fontFamilies = isCartazFormat(styles.format)
    ? CARTAZ_FONTS
    : ENCARTE_FONT_FAMILIES;

  useEffect(() => {
    const validFonts = isCartazFormat(styles.format)
      ? CARTAZ_FONTS
      : ENCARTE_FONT_FAMILIES;
    if (!validFonts.includes(styles.fontFamily)) {
      onStylesChange("fontFamily", validFonts[0]);
    }
  }, [styles.format]);

  return { fontFamilies };
}
